import { getVisitorProfileImageUrl } from "../utils/visitors.utils";

const VisitorAvatar = ({ visitor }) => {
  const imageUrl = getVisitorProfileImageUrl(visitor);
  const initials = String(visitor?.name || "?")
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");

  if (!imageUrl) {
    return (
      <div
        className="d-flex align-items-center justify-content-center bg-light text-muted"
        style={{
          width: "40px",
          height: "40px",
          borderRadius: "50%",
          border: "1px solid #dee2e6",
          fontSize: "12px",
          fontWeight: 600,
          flexShrink: 0,
        }}
        aria-hidden="true"
      >
        {initials || "?"}
      </div>
    );
  }

  return (
    <img
      src={imageUrl}
      alt={visitor?.name || "Visitor"}
      style={{
        width: "40px",
        height: "40px",
        objectFit: "cover",
        borderRadius: "50%",
        border: "1px solid #dee2e6",
        flexShrink: 0,
      }}
    />
  );
};

const VisitorsTable = ({ visitors = [], onView }) => {
  return (
    <div className="table-responsive">
      <table className="table table-striped mb-0">
        <thead>
          <tr>
            <th style={{ minWidth: 200 }}>Name</th>
            <th style={{ minWidth: 140 }}>CNIC</th>
            <th style={{ minWidth: 130 }}>Phone</th>
          </tr>
        </thead>
        <tbody>
          {visitors.map((visitor, index) => {
            const id = visitor._id || visitor.id;

            return (
              <tr
                key={id || `visitor-${index}`}
                role="button"
                tabIndex={0}
                style={{ cursor: onView ? "pointer" : undefined }}
                onClick={() => onView?.(visitor)}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    event.preventDefault();
                    onView?.(visitor);
                  }
                }}
              >
                <td>
                  <div className="d-flex align-items-center gap-2">
                    <VisitorAvatar visitor={visitor} />
                    <span>{visitor.name || "-"}</span>
                  </div>
                </td>
                <td>{visitor.cnic || "-"}</td>
                <td>{visitor.contact_number || "-"}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default VisitorsTable;
